export const getFcp = () => {
  const fcp = performance?.getEntriesByName('first-contentful-paint')?.[0]?.startTime;
  if (fcp > 0) {
    return fcp;
  }
  // @ts-ignore
  if (window?.chrome?.loadTimes) {
    // @ts-ignore
    const {firstPaintTime, startLoadTime} = window.chrome.loadTimes();
    return (firstPaintTime - startLoadTime) * 1000;
  }
  return 0;
};

export const getFmp = () => {
  if (performance?.mark) {
    return performance?.mark('fmp')?.startTime;
  }
  if (performance?.now) {
    return performance.now();
  }
  return 0;
};

